export const API_URL = {aircraft: 'https://bg.polet.vdnh.ru/api/media/'};